<div class="wiz-component-container" width="100%" height="100%"  [ngClass]="{'disabled-class': wizDisabled}">
    <!-- label -->
    <div  class="wiz-component-label" width="100%" *ngIf="wizShowLabel">
      <wiz-label  id="label" #innerLabel [wizLabel]="wizLabel" [wizTextBehavior]="'truncate'"
      [ngClass]="{'error-class': hasErrors}"></wiz-label><!-- label -->
      <span #innerAsterisk *ngIf="wizMandatory" class='mandatory-class'
      >*</span><!-- asterisque -->
    </div>

    <!-- le form field. C'est lui qui sera skinné -->
    <mat-form-field #formField floatLabel="never" id="inzone"
    class="wiz-component-field innerfocus-class"
    [ngClass]="{'error-class': hasErrors,'innerchildfocus-class':popUpOpened, 'has-clear-icon': showClearIcon()}">

    <!-- le calendar (ou plutôt le container du calendar) -->
    <wiz-datepicker #datePicker [dateClass]="dateClass" [panelClass]="['wiz-date-picker',wizExtraClassDatePicker]"
    (opened)='popOpened()' (closed)='popClosed()'
    [disabled]="wizDisabled" [startView]="wizDateMode"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event)"
    ></wiz-datepicker>

    <!-- bouton ouverture datepicker -->
    <mat-datepicker-toggle matPrefix
        
        tabindex="-1" #datepickerToggle
        class="innerIcon fix-calendar-icon"
        [for]="datePicker"
        *ngIf="!wizDisabled"
        [ngClass]="{'error-class': hasErrors}">
       
        <mat-icon matDatepickerToggleIcon><wiz-icon id="ico" class="smallMe">calendar</wiz-icon></mat-icon>
    </mat-datepicker-toggle>
    <wiz-spacer width="10px" *ngIf="!!wizDisabled"></wiz-spacer>

    <!--le champ de saisie. Input width à 'auto' permet de prendre toute la place en largeur -->
    <input matInput #dateInput
      class="wiz-input"
      [matDatepicker]="datePicker"
      [ngModel]="getWizValue()"
      (click)="inputClic($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
      [placeholder]="translatedPlaceholder"
      [readonly]="getReadOnly()"
      [min]="wizMinDate"
      [max]="wizMaxDate"
      [style.cursor]="getInputPointer()"
      [disabled]="wizDisabled"
      autocomplete="off"
      [tabIndex]="wizTabIndex"/>

      <!-- bouton "clear" -->
      <mat-icon id="ico" #innerClearIcon matSuffix *ngIf="showClearIcon()" (click)="clearDate($event)" class="innerIcon fix-calendar-icon">close</mat-icon>
    </mat-form-field>

    <div width="100%" class="wiz-component-hint">
      <!-- le hint -->
      <wiz-label #innerhint class="hint-class" *ngIf="wizHint" [wizLabel]="wizHint"></wiz-label>
      <!-- l'affichage de l'erreur -->
      <ng-container #errorContainer id="error"></ng-container>
    </div>

</div>
